import { types, flow, getSnapshot } from "mobx-state-tree";

import { getUsers } from "api/user";

import BaseBackboneCollectionMigrationStore from "../backbone-collection-template";

import { UserStore } from "./user-store";

const model = {
    users: types.optional(types.array(UserStore), []),
    isLoading: true
};

const volatile = () => ({});

const views = (self) => ({
    get length() {
        return self.users.length;
    },

    getActiveUsers() {
        return self.users.filter((user) => user.isActive);
    },

    getUsersAsRawObjects() {
        return self.users.map((model) => getSnapshot(model));
    },

    getUserById(userId: string) {
        return self.users.find((user) => user.userId === userId);
    },

    getActiveWithoutRole(roleName: string) {
        return self.users.filter(
            (user) => user.isActive && !user.hasRole(roleName)
        );
    },

    filterByRole(role: string) {
        return self.users.filter(
            (user) => user.role.toUpperCase() === role?.toUpperCase()
        );
    },

    filterByNotRole(role: string) {
        return self.users.filter(
            (user) => user.role.toUpperCase() !== role?.toUpperCase()
        );
    }
});

const actions = (self) => ({
    /**
     * @summary Resets entire users list with new UserStore models
     * @param {Array} users
     */
    resetUsers(users) {
        self.users = users.map((user) => {
            return UserStore.create(user);
        });
    },
    /**
     * @summary Make an api call to fetch all users
     * @async
     * @return {Users | Error}
     */
    fetch: flow(function* fetch() {
        try {
            self.isLoading = true;
            const data = yield getUsers();
            self.users = data;
            return self.users;
        } catch (error) {
            console.error(error);
            return error;
        } finally {
            self.isLoading = false;
        }
    })
});

const _UsersStore = types
    .model(`Users`, model)
    .volatile(volatile)
    .views(views)
    .actions(actions);

export const UsersStore = BaseBackboneCollectionMigrationStore<
    typeof _UsersStore
>(_UsersStore, UserStore, `users`);
